import { Dropdown, TextField } from 'office-ui-fabric-react';
import * as React from 'react';

import * as FormStyle from '../../../../Common/Styles/form.styled';
import { MachineLearningExperimentWizardStep } from './MachineLearningExperimentWizard';
import {
  MachineLearningExperimentWizardContext,
  MachineLearningExperimentWizardContextProps,
} from './MachineLearningExperimentWizardContext';

export function MachineLearningExperimentModelWizardStep(): React.ReactElement {
  const { experiment, setCompletedSteps, completedSteps } =
    React.useContext<MachineLearningExperimentWizardContextProps>(MachineLearningExperimentWizardContext);

  React.useEffect(() => {
    if (!!experiment.type && completedSteps.indexOf(MachineLearningExperimentWizardStep.MODEL) === -1) {
      setCompletedSteps([...completedSteps, MachineLearningExperimentWizardStep.MODEL]);
    }
  }, [completedSteps, experiment.type, setCompletedSteps]);

  return (
    <FormStyle.MinimumForm>
      <FormStyle.InputGroup>
        <h2>Model configuration</h2>
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <h3>Unsupervised model</h3>
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <Dropdown
          label="Unsupervised model"
          options={[
            {
              key: 'IsolationForest',
              text: 'Isolation Forest',
            },
          ]}
          onChange={() => {}}
          selectedKey={experiment.modelConfiguration.unsupervisedModel}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="contamination"
          id="contamination"
          required={true}
          value={experiment.modelConfiguration.unsupervisedModelConfiguration.contamination?.toString()}
          onChange={() => {}}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="max_samples"
          id="max_samples"
          required={true}
          value={experiment.modelConfiguration.unsupervisedModelConfiguration.max_samples?.toString()}
          onChange={() => {}}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="n_estimators"
          id="n_estimators"
          required={true}
          value={experiment.modelConfiguration.unsupervisedModelConfiguration.n_estimators?.toString()}
          onChange={() => {}}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="random_state"
          id="random_state"
          required={true}
          value={experiment.modelConfiguration.unsupervisedModelConfiguration.random_state?.toString()}
          onChange={() => {}}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <h3>Supervised model</h3>
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <Dropdown
          label="Supervised model"
          options={[
            {
              key: 'RandomForest',
              text: 'Random Forest',
            },
            {
              key: 'NeuralNetwork',
              text: 'Neural Network',
            },
          ]}
          onChange={() => {}}
          selectedKey={experiment.modelConfiguration.supervisedModel}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="max_samples"
          id="max_samples"
          required={true}
          value={experiment.modelConfiguration.supervisedModelConfiguration.max_samples?.toString()}
          onChange={() => {}}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="n_estimators"
          id="n_estimators"
          required={true}
          value={experiment.modelConfiguration.supervisedModelConfiguration.n_estimators?.toString()}
          onChange={() => {}}
          disabled
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="random_state"
          id="random_state"
          required={true}
          value={experiment.modelConfiguration.supervisedModelConfiguration.random_state?.toString()}
          onChange={() => {}}
          disabled
        />
      </FormStyle.InputGroup>
    </FormStyle.MinimumForm>
  );
}
